module.exports = __webpack_public_path__ + "ecf0a35a7a3534f8bc52d48845198de3.png";